import { filterPartiesByPartyTypeCode } from "./filterPartiesByPartyTypeCode";

export const getAllContingentBeneficiaryFromParties = (parties) => {
  return filterPartiesByPartyTypeCode(parties, ["CB"]);
};
